import label from "../../../utils/constant/label";
import * as actionType from "../../constants/actionsType";

export function getAddToCart(id,data, onSuccess,onFailure) {

    return (dispatch) => {
      getAddToCartAction(dispatch,id,data, onSuccess,onFailure);
      }
  }
  function getAddToCartAction(dispatch,id,data, onSuccess,onFailure) {

       dispatch({
        type: actionType.ADD_TO_CART,
        id,data,
      })
      onSuccess(label.messages.success)
    //   dispatch({
    //     type: actionType.EMPTY_LOGIN_DETAILS,
    //     payload: [],
    //   })
      // dispatch({
      //   type: actionType.LOGIN_DETAILS,
      //   payload: data,
      // })
      // onSuccess()
      // dispatch({
      //   type: actionType.LOADER_LOGIN_DETAILS,
      //   payload: false,
      // })
    //   Networking.PostApi(url.Login,data)
    //   .then(result=>{ 
    //     if(result.status=="S"){
    //       if(result.data!=null){
    //         if(JSON.parse(result.data).Table[0].Status=="S"){
    //           dispatch({
    //             type: actionType.LOADER_LOGIN_DETAILS,
    //             payload: false,
    //           })
    //           dispatch({
    //             type: actionType.LOGIN_DETAILS,
    //             payload:JSON.parse(result.data),
    //           })
    //         onSuccess(JSON.parse(result.data).Table[0].Message)
    //         }else{
    //           dispatch({
    //             type: actionType.LOADER_LOGIN_DETAILS,
    //             payload: false,
    //           })
    //         onFailure(JSON.parse(result.data).Table[0].Message)
    //         }
    //       }else{
    //         onFailure(label.messages.apiError)
    //       }
       
       
    //     }else{
    //       dispatch({
    //         type: actionType.LOADER_LOGIN_DETAILS,
    //         payload: false,
    //       })
    //     onFailure("Kindly enter valid Sign-in code")
    //     }
    //     })
    //   .catch(function (error) {
    //     onFailure(label.messages.apiError)
    //       dispatch({
    //         type: actionType.LOADER_LOGIN_DETAILS,
    //         payload: false,
    //       })
    //            // 
    //    });
  //  setTimeout(() => {

  }
  
export function getDeleteCart(data, onSuccess,onFailure) {

  return (dispatch) => {
    getDeleteCartAction(dispatch,data, onSuccess,onFailure);
    }
}
function getDeleteCartAction(dispatch,data, onSuccess,onFailure) {

     dispatch({
      type: actionType.DELETE_CART,
      payload: data,
    })
    // onSuccess(label.messages.success)

}

export const emptyCart=()=>{
  return{
    type:actionType.EMPTY_CART,
    payload:[]
  }
}

  